import axios from "axios";
import qs from "qs";
import store from "../store/index.js";
import { Message } from "element-ui";

// const url = "https://zjzxadmin.jc881.com";
//正式
const url = "http://zjqyadmin.ynbzde.com";

/**
 * 接口异常抛除的对象
 */
class ApiError extends Error {
  toString() {
    return this.message;
  }
}

const request = axios.create({
  baseURL: url,
  transformRequest: [
    function(data) {
      return qs.stringify(data);
    }
  ]
});

// 使用拦截器添加token字段
request.interceptors.request.use((config) => {
  if (store.state.userinfo !== null) {
    config.headers.token = store.state.userinfo.token;
  }
  return config;
});

// AJAX 创建
request.interceptors.response.use(
  (response) => {
    if (typeof response.data.code === "undefined") {
      return response.data;
    }
    // 如果后台传递过来的 code 是 1 就直接返回数据
    // 1成功 2失败 400未登录
    if (parseInt(response.data.code) === 1) {
      return response.data.data;
    } else {
      const msg = response.data.msg || "请求错误,请稍后重试";
      Message.error(msg);
      return Promise.reject(new ApiError(response.data.msg));
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const skk_axios = request;

export default {
  url,
  request
};
